import React, { useState } from 'react';
import { useGetIDsFromURL } from '../helper';
import { useBatteryModuleStates } from './service';
import { batteryModulesTableColumns } from './tableColumns';
import { HGTable, TableSkeleton } from 'components/HGTable';

const BatteryModulesTable = () => {
    const { Thing_ID, BMS_ID } = useGetIDsFromURL();
    const { tableData, isLoading } = useBatteryModuleStates(Thing_ID, BMS_ID);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <div>
            {isLoading ? (
                <TableSkeleton columns={batteryModulesTableColumns} />
            ) : !tableData || tableData.length === 0 ? (
                <div className="flex flex-col justify-center">
                    <h2 className="text-center opacity-20">
                        No Battery Modules Available
                    </h2>
                </div>
            ) : (
                <HGTable
                    columns={batteryModulesTableColumns}
                    data={tableData}
                    rowsHref={(item) =>
                        BMS_ID
                            ? `/devices/${Thing_ID}/${BMS_ID}/${item.P_serialNumber}`
                            : `/devices/${Thing_ID}/${item.P_serialNumber}`
                    }
                    sortField={sortField}
                    setSortField={setSortField}
                    sortDirection={sortDirection}
                    setSortDirection={setSortDirection}
                    currentPage={1}
                    setCurrentPage={() => {}}
                    pageSize={tableData.length}
                    totalItems={tableData.length}
                />
            )}
        </div>
    );
};

export default BatteryModulesTable;
